import { render, staticRenderFns } from "./Biorythme.vue?vue&type=template&id=0979404e&"
import script from "./Biorythme.vue?vue&type=script&lang=js&"
export * from "./Biorythme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports